import * as React from "react";
import Payment from "../../../model/payment/Payment";
import DateUtils from "../../../utils/DateUtils";
import CurrencyHelper from "../../../helper/CurrencyHelper";
import PaymentRecommendation from "../../../model/payment/PaymentRecommendation";
import IconWrapper from "../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import "./commonDetailsSummary.scss";

interface IProps {
	/**
	 * Payments.
	 */
	payments: Payment[];
	/**
	 * Payment recommendations.
	 */
	paymentRecommendations: PaymentRecommendation[];
	/**
	 * Total invoice value.
	 */
	totalValue: number;
}

export const PaymentsSummary: React.SFC<IProps> = (props) => {
	const amountDue: number = getAmountDue(props.payments, props.totalValue);
	return (
		<div className="c-common-summary_container extra-width">
			{props.payments.map((item, index) => renderPaymentOrRecommendation(item, index, props.totalValue))}
			{props.paymentRecommendations.map((item, index) => renderPaymentOrRecommendation(item, index, props.totalValue))}
			<div className="c-common-summary_last-item">
				<div className="c-common-summary_item_label extended-flex-basis">Amount due</div>
				<div className="c-common-summary_item_label">{CurrencyHelper.toCurrency(amountDue)}</div>
			</div>
			<div className="c-common-summary_item_horizontal-line has-margin-bottom"/>
			<div className="c-common-summary_item_horizontal-line"/>
		</div>
	);
};

const getAmountDue = (invoicePayments: Payment[], invoiceTotal: number): number => {
	const paymentsSum = invoicePayments.reduce((a, b) => a + b.amount, 0);
	return invoiceTotal - paymentsSum;
};

const renderPaymentOrRecommendation = (item: Payment | PaymentRecommendation, index: number, totalAmount: number) => {
	const paymentLabelItem = item instanceof Payment ?
		<div>
			{item.amount < totalAmount ? "Less" : "Full"}
			<span className="c-common-summary_item_payment-label"> Payment</span>
		</div> :
		<div>
			<IconWrapper icon={Icon.Alert} size={12} variant="burgundy"/>
			<span className="c-common-summary_item_payment-label"> Unconfirmed payment</span>
		</div>;
	return (
		<>
			<div key={index} className="c-common-summary_item has-padding-top">
				<div className="c-common-summary_item_label extended-flex-basis">
					{paymentLabelItem}
					<div className="c-common-summary_item_label_payment-date">{item.datePaid.format(
						DateUtils.FULL_MONTH_NAME_DATE_FORMAT)}</div>
				</div>
				<span className="c-common-summary_item_label c-common-summary_item_payment-label">
					{CurrencyHelper.toCurrency(item.amount)}
				</span>
			</div>
			<div className="c-common-summary_item_horizontal-line"/>
		</>
	);
};
